import { useQuery } from '@tanstack/react-query';
import { env } from '@/config/env';
import { useAuth } from '@/hooks/useAuth';
import { billingApi } from '../api/billingApi';
import { getOrganizationId } from '../utils/billingOrganization';

export const onboardingKeys = {
  root: (organizationId?: string) => ['billing-onboarding', organizationId ?? 'none'] as const
};

/**
 * GET /billing/onboarding/ — the post-login routing source of truth. Powers the
 * OnboardingGate (next_step) and, later, the proactive read-only / paywall mode
 * (steps.subscription_active). Mirrors useBillingStatus' gating: only runs for a
 * logged-in user when the billing frontend is enabled.
 */
export const useOnboarding = () => {
  const { user } = useAuth();
  const organizationId = getOrganizationId(user);

  return useQuery({
    queryKey: onboardingKeys.root(organizationId),
    queryFn: () => billingApi.getOnboarding(),
    enabled: Boolean(user && env.billingEnabled),
    networkMode: 'online',
    staleTime: 60 * 1000
  });
};
